import React, {useEffect, useRef, useState} from "react";
import CommonHeader from "../../components/common-header";
import styled from "styled-components";
import {Avatar, Button, Checkbox, Divider, Form, Image, Input, Layout, message, Space, Tag} from "antd";
import {ShareAltOutlined, UserOutlined} from '@ant-design/icons';
import {Content} from "antd/es/layout/layout";
import HtmlToReactParser from "html-to-react";
import {BaseImageUrl, ShareUrl} from "../../http/http";
import {useStore} from "../../store";
import {debounce} from "lodash";
import {addCommentInfo, addRead, getCommentInfo, getPopularInfo} from '../../http/home';
import {CommentEntity} from '../../entity/comment-entity';
import {transaction} from "mobx";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {observer} from "mobx-react";


const PublicityDetail: React.FC = () => {
    const {scienceStore} = useStore();
    const [details, setDetail] = useState({
        title: '',
        creater: '',
        createtime: '',
        category: '',
        content: '',
        userImg: '',
        source: '',
        id: ''
    })
    const {TextArea} = Input;
    const [isAnonymous, setIsAnonymous] = useState(false);
    const [commentData, setCommentData] = useState<CommentEntity[]>([]);
    const [form] = Form.useForm();
    let ID = useRef<string | null>();

    useEffect(() => {
        const href = window.location.href;
        const urlObj = new URL(href);
        ID.current = urlObj.searchParams.get('id');
        toGetPopularInfo();
        toAddRead(ID.current);
        return;
    }, [])
    const toGetPopularInfo = () => {
        let params = {
            id: ID.current
        }
        getPopularInfo(params).then((res: any) => {
            setDetail(res.data.list[0]);
            getList();
        }).catch((e) => {
            console.log("error:" + e.message)
        })
    }
    const getList = () => {
        let params = {
            pid: ID.current
        }
        getCommentInfo(params).then((res: any) => {
            refreshTableData((res.data && res.data.length > 0) ? res.data : []);
        }).catch((e) => {
            console.log("error:" + e.message)
        })
    }
    const toAddRead = (id: any) => {
        const formData = new FormData();
        formData.append('pid', id);
        addRead(formData).catch((e) => {
            console.log("error:"+e.message)
        })
    }
    const refreshTableData = (data: CommentEntity[]) => {
        const list: CommentEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        transaction(() => {
            scienceStore.setCommentSource(list);
            setCommentData(list);
        })
    }
    const onChangeAnonymous = (e: CheckboxChangeEvent) => {
        setIsAnonymous(e.target.checked);
        if (e.target.checked) {
            scienceStore.userName = "游客" + new Date().getTime()
        } else {
            scienceStore.userName = ""
        }
    };
    const submit = () => {
        if (scienceStore.comment === undefined || !scienceStore.comment) {
            message.info({
                content: "请输入评论"
            })
            return;
        }
        if (!isAnonymous && !scienceStore.userName) {
            message.info({
                content: "请输入名称"
            })
            return;
        }
        publicityDebounce();
    };
    const save = () => {
        const formData = new FormData();
        formData.set("anonymous", isAnonymous ? "1" : "0");
        formData.set("userid", scienceStore.userName.toString());
        formData.set("pid", details.id);
        formData.set("content", scienceStore.comment);
        addCommentInfo(formData)
            .then((res: any) => {
                if (res && res.data) {
                    message.success("评论成功！");
                    scienceStore.clearComment();
                    form.resetFields();
                    setIsAnonymous(false)
                    getList();
                } else {
                    message.error("评论失败！");
                }
            }).catch((e) => {
            console.log("error:" + e.message)
        })
    };
    const publicityDebounce = debounce(save, 500);
    const onChangeContent = (e: any) => {
        scienceStore.setComment(e.target.value)
    }
    const onChangeName = (e: any) => {
        scienceStore.setUserName(e.target.value)
    }
    return (<Wrapper>
        <Layout style={{padding: "0"}}>
            <CopyToClipboard text={`${ShareUrl}home/publicity/detail?id=${ID.current}`}
                             onCopy={() => message.success('复制成功~')}>
                <div className="shareBtn">
                    <ShareAltOutlined style={{fontSize: '32px', color: 'green'}}/>
                </div>
            </CopyToClipboard>
            <CommonHeader showLogin={false} showBack={true}/>
            <Content style={{ padding: "15px 40px"}}>
                <SubWrapper>
                    <TitleSpan>{details.title}</TitleSpan>
                    <Space size={[0, 8]} wrap>
                        {
                            details.category ? details.category.split(',').map((category: string) => {
                                return <Tag color={"orange"} key={category}>{category}</Tag>
                            }) : ''
                        }
                    </Space>
                    <Space size={[10, 10]} style={{margin: "10px 0"}}>
                        {
                            details.userImg ?
                                <Image width={24} style={{borderRadius: '50%'}} src={BaseImageUrl + details.userImg} preview={false}/> :
                                <Avatar shape="circle" size="small" icon={<UserOutlined/>}/>
                        }
                        <span style={{color: "green"}}>{details.creater}</span>
                        <span>{details.source}</span>
                        <span>{details.createtime}</span>
                    </Space>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        {HtmlToReactParser.Parser().parse(details.content)}
                    </div>
                    <DividerWrapper/>
                    <StatusWrapper>
                        <h2>发表评论</h2>
                        <Form form={form} style={{marginBottom:"-10px"}}>
                            <Form.Item name="userName" style={{marginBottom:"15px"}}>
                                <NameContent>
                                    <Checkbox onChange={onChangeAnonymous} checked={isAnonymous}>匿名发表</Checkbox>
                                    <Input value={scienceStore.userName} style={{width: '300px', marginTop:"10px"}} onChange={onChangeName}
                                                           placeholder="请输入姓名"/>
                                </NameContent>
                            </Form.Item>
                            <Form.Item name="comment" >
                                <TextArea rows={4} onChange={onChangeContent}
                                          placeholder={"请写下您宝贵的评论"}></TextArea>
                            </Form.Item>
                        </Form>
                        <div>
                            <Button type="primary" size="large" shape="round" onClick={submit}>发表</Button>
                        </div>
                    </StatusWrapper>
                    <DividerWrapper/>
                    <h2>全部评论&nbsp;{commentData.length}</h2>
                    {
                        commentData.map((item: any) => {
                            return <CommentWrapper key={item.id}>
                                <CommentTitleWrapper>
                                    <p className="content"><NameSpan>{item.userid}</NameSpan> : {item.content}</p>
                                    <p>{item.createtime}</p>
                                </CommentTitleWrapper>
                                <Divider type={"horizontal"}/>
                            </CommentWrapper>
                        })
                    }
                </SubWrapper>
            </Content>
        </Layout></Wrapper>);
}

export default observer(PublicityDetail);

const Wrapper = styled.div`
  & {
    width: 100%;
    min-width: 1200px;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    flex: 1;

    .shareBtn {
      position: fixed;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: #fff;
      right: 20px;
      top: 50%;
      margin-top: -36px;
      box-shadow: 1px 1px 1px 1px #ccc, 1px 1px 1px -3px #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: all .6s;
      cursor: pointer;
      z-index: 99;

      &:hover {
        box-shadow: 1px 1px 1px 1px #999;
      }
    }
  }
`;
const SubWrapper = styled(Wrapper)`
  & {
    margin: 0 auto;
    width: 65%;
    background: white;
    padding: 0 30px;
    border: 1px solid #eeeeee;
    border-radius: 5px;
  }
`;

const TitleSpan = styled.span`
  & {
    font-size: 25px;
    font-weight: 500;
    line-height: 40px;
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;
const StatusWrapper = styled.div`
  & {
    display: flex;
    margin-bottom: 15px;
    flex-direction: column;
    h2 {
      width: 100%;
    }
  }
`;
const NameSpan = styled.span`
  & {
    font-size: 16px;
    display: flex;
    color: #4C77FA;
  }
`;
const NameContent = styled.div`
  & {
    display: flex;
    flex-direction: column;
  }
`
const CommentWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    overflow: hidden;
  }
`;

const CommentTitleWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    p {
      margin: 0;
    }
    .content {
        padding-bottom: 8px;
        display: flex;
        color: rgba(0,0,0,0.9);
    }
    p:last-child {
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
  }
`;
const CommentContentWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    font-size: 16px;
    color: #333333;
    padding: 12px 0;
  }
`;
const DividerWrapper = styled.div`
  & {
    display: flex;
    height: 2px;
    margin: 0 -30px;
    background: #DEDEDE;
  }

`;